export const common = {
  nav: {
    services: 'Услуги',
    about: 'О нас',
    contact: 'Контакты'
  },
  hero: {
    title: 'Профессиональные Сайты и SEO для Малого Бизнеса',
    subtitle: 'Я создаю современные, быстрые и оптимизированные веб-сайты, чтобы помочь местному бизнесу расти в интернете.',
    primaryBtn: 'Запросить информацию',
    secondaryBtn: 'Посмотреть услуги'
  },
  services: {
    title: 'Услуги',
    web: {
      title: 'Создание Веб-сайтов',
      description: 'Дизайн современных, быстрых и адаптивных веб-сайтов для малого бизнеса.'
    },
    seo: {
      title: 'Локальное SEO',
      description: 'Оптимизация для лучшего ранжирования в Google и привлечения местных клиентов.'
    },
    redesign: {
      title: 'Редизайн Сайтов',
      description: 'Преобразование старых сайтов в современные и профессиональные.'
    }
  },
  why: {
    title: 'Почему Выбрать David Rio Web',
    point1: 'Современный и профессиональный дизайн',
    point2: 'Быстрые и оптимизированные сайты',
    point3: 'Структура готова для SEO',
    point4: 'Поддержка нескольких языков',
    point5: 'Решения для малого бизнеса'
  },
  languages: {
    title: 'Многоязычные Услуги',
    description: 'Я работаю с компаниями, которые хотят привлечь международных клиентов.',
    spanish: 'Español',
    english: 'English',
    russian: 'Русский'
  },
  about: {
    title: 'О David Rio',
    description: 'Фрилансер веб-разработчик, специализирующийся на создании современных веб-сайтов и SEO-стратегий для малого бизнеса. Моя цель - помочь местным компаниям иметь профессиональное присутствие в интернете.'
  },
  contact: {
    title: 'Контакты',
    name: 'Имя',
    email: 'Email',
    phone: 'Телефон',
    message: 'Сообщение',
    submit: 'Связаться',
    sending: 'Отправка...',
    success: 'Сообщение успешно отправлено!',
    error: 'Ошибка отправки сообщения. Пожалуйста, попробуйте снова.'
  },
  footer: {
    copyright: '© 2026 David Rio Web',
    credit: 'Сайт разработан и создан David Rio'
  },
  portfolio: {
    title: 'Веб-проекты',
    description: 'Несколько примеров современных веб-сайтов, разработанных для малого бизнеса.',
    project1: {
      title: 'Сайт для местного бизнеса',
      description: 'Современный сайт для местного сервисного бизнеса с мобильной оптимизацией и быстрой загрузкой.'
    },
    project2: {
      title: 'Сайт для ресторана',
      description: 'Профессиональный сайт для ресторана, включая меню, местоположение и контакты.'
    },
    project3: {
      title: 'Сайт для салона красоты',
      description: 'Элегантный сайт для салона красоты с услугами и галереей.'
    }
  },
  process: {
    title: 'Как я работаю',
    step1: {
      title: 'Анализ',
      description: 'Изучаю потребности бизнеса и цели клиента.'
    },
    step2: {
      title: 'Дизайн и разработка',
      description: 'Создаю современный, быстрый и оптимизированный сайт.'
    },
    step3: {
      title: 'Публикация и оптимизация',
      description: 'Сайт публикуется и оптимизируется для поисковых систем.'
    }
  }
};